var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 21,
    viewBox: "0 0 39 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 37,
    height: 20,
    rx: 5.33,
    fill: "#F7F7F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 37,
    height: 20,
    rx: 5.33,
    stroke: "#D7D8E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_2772)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6455 5.03125C20.2658 5.03125 19.958 5.32506 19.958 5.6875C19.958 6.04994 20.2658 6.34375 20.6455 6.34375H23.6247V12.0312H16.1178L17.6942 10.5265C17.9626 10.2703 17.9626 9.85474 17.6942 9.59846C17.4257 9.34218 16.9904 9.34218 16.7219 9.59846L13.975 12.2205C13.974 12.2215 13.9729 12.2225 13.9719 12.2235C13.8373 12.3519 13.7702 12.5204 13.7705 12.6887C13.7705 12.7024 13.771 12.7161 13.7719 12.7298C13.7817 12.8749 13.8417 13.0174 13.9519 13.1317C13.959 13.1391 13.9663 13.1463 13.9738 13.1534L16.7219 15.7765C16.9904 16.0328 17.4257 16.0328 17.6941 15.7765C17.9626 15.5203 17.9626 15.1047 17.6941 14.8485L16.1178 13.3438H24.3122C24.6919 13.3438 24.9997 13.0499 24.9997 12.6875V5.6875C24.9997 5.32506 24.6919 5.03125 24.3122 5.03125H20.6455Z",
    fill: "#585971"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_2772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIcon1);
export default __webpack_public_path__ + "static/media/guide-icon-1.446f171b27f347b2813af38f651b6f49.svg";
export { ForwardRef as ReactComponent };